
  export default{
     name: 'ProductPage',
     data(){
       return{
          cateList: [{
              key: "square",
              selected: true,
              name: "不锈钢消防水箱",
            },
            {
              key: "warm",
              name: "不锈钢保温水箱",
            },
            {
              key: "life",
              name: "不锈钢生活水箱",
            },
            {
              key:"ic",
              name: "巧克力水箱",
            },
            {
              key:"clean",
              name: "不锈钢承压水箱",
            },
            {
              key:"bdf",
              name: "BDF水箱",
            },
            {
              key:"land",
              name: "地埋式水箱",
            },
            {
              key:"cycle",
              name: "圆柱形水箱",
            },
            {
              key:"space",
              name: "油水分离器",
            },
            {
              key:"room",
              name: "一体化智慧泵房",
            },
            {
              key:"clear",
              name: "水箱消毒器",
            },
            {
              key:"lift",
              name: "污水提升设备",
            },
            {
              key:"provide",
              name: "无负压供水设备",
            },
            {
              key: "fountain",
              name: "喷泉",
            }
          ],
          productList: [],
          productTmp:{},

          // 瀑布流相关配置
          columns: 4,  // 瀑布流列数
          columnWidth: 0,  // 每列宽度
          columnHeights: [],  // 每列高度
          loadedItems: 0,  // 已加载的项数
          isWaterfallInit: false,  // 瀑布流是否初始化完成
          resizeTimer: null,  // 窗口大小变化的定时器
       }
     },
     async asyncData(context) {
       /* let productData = await context.$request.productMgr.getCateType("square");

       return {
         productList:productData.list || [],
       } */
     },
     mounted(){

       this.getProduct("square");

       // 添加窗口大小变化监听
       window.addEventListener('resize', this.handleResize);
     },
     // 组件销毁时移除事件监听
     beforeDestroy() {
       if (this.resizeTimer) {
         clearTimeout(this.resizeTimer);
       }
       window.removeEventListener('resize', this.handleResize);
     },
     methods:{
       getSessionStorage(key){
         return window.sessionStorage.getItem(key)? JSON.parse(window.sessionStorage.getItem(key)) :null;
       },
       setSessionStorage(key,data){
          window.sessionStorage.setItem(key,JSON.stringify(data));
       },
       onCate(item) {
         for (let cate of this.cateList) {
           this.$set(cate, "selected", false);
         }
         this.$set(item, "selected", true);

         if (!this.productTmp[item.key]) {
           this.getProduct(item.key);
         } else {
           this.productList = this.productTmp[item.key].list || [];
         }
       },
       getProduct(key) {
         const localData=this.getSessionStorage(key) || {};
         if(localData.list && localData.list.length>0){
             this.productList = localData.list || [];
             this.productTmp[key] = localData || {};
             this.$nextTick(() => {
               this.loadedItems = 0;
               this.initWaterfall();
             });
             return;
         }

         this.$request.productMgr.getCateType(key).then((result) => {
           if(result){
              this.productList = result.list || [];
              this.productTmp[key] = result || {};
              this.$nextTick(() => {
                this.loadedItems = 0;
                this.initWaterfall();
              });
              this.setSessionStorage(result.key,result);
           }
         });
       },

       // 初始化瀑布流
       initWaterfall() {
         const container = this.$el.querySelector('.waterfall-container');
         if (!container || this.productList.length === 0) return;

         // 计算列宽
         this.columnWidth = (container.clientWidth - -10) / this.columns; // 40是左右margin的总和

         // 重置列高度数组
         this.columnHeights = new Array(this.columns).fill(0);

         // 处理所有已加载的项
         this.renderWaterfall();

         this.isWaterfallInit = true;
       },

       // 渲染瀑布流布局
       renderWaterfall() {
         const items = this.$refs.waterfallItems;
         if (!items || items.length === 0) return;

         for (let i = 0; i < items.length; i++) {
           const item = items[i];
           const content = item.querySelector('.waterfall-content');

           // 设置项的宽度
           content.style.width = `${this.columnWidth - 20}px`; // 20是padding的总和

           // 找到最矮的列
           let minHeight = Math.min(...this.columnHeights);
           let minIndex = this.columnHeights.indexOf(minHeight);

           // 设置项的位置
           item.style.width = `${this.columnWidth}px`;
           item.style.left = `${minIndex * this.columnWidth}px`;
           item.style.top = `${minHeight}px`;

           // 添加显示动画
           this.$nextTick(() => {
             item.classList.add('visible');
           });

           // 更新列高度
           // 由于图片可能还没加载完成，这里先使用一个默认高度，图片加载后会重新布局
           const defaultHeight = 200; // 默认高度
           this.columnHeights[minIndex] += defaultHeight + 20; // 20是margin的总和
         }

         // 更新容器高度
         const container = this.$el.querySelector('.waterfall-container');
         if (container) {
           container.style.height = `${Math.max(...this.columnHeights)}px`;
         }
       },

       // 重新计算瀑布流布局
       reflowWaterfall() {
         if (!this.isWaterfallInit) return;

         // 重置列高度数组
         this.columnHeights = new Array(this.columns).fill(0);

         const items = this.$refs.waterfallItems;
         const images = this.$refs.waterfallImages || [];
         const videos = this.$refs.waterfallVideos || [];

         if (!items || items.length === 0) return;

         for (let i = 0; i < items.length; i++) {
           const item = items[i];
           const content = item.querySelector('.waterfall-content');

           // 找到最矮的列
           let minHeight = Math.min(...this.columnHeights);
           let minIndex = this.columnHeights.indexOf(minHeight);

           // 设置项的位置
           item.style.left = `${minIndex * this.columnWidth}px`;
           item.style.top = `${minHeight}px`;

           // 获取真实内容高度（图片或视频加载完成后）
           let itemHeight = content.offsetHeight;

           // 更新列高度
           this.columnHeights[minIndex] += itemHeight + 20; // 20是margin的总和
         }

         // 更新容器高度
         const container = this.$el.querySelector('.waterfall-container');
         if (container) {
           container.style.height = `${Math.max(...this.columnHeights)}px`;
         }
       },

       // 图片加载完成后的回调
       onWaterfallImageLoad(index) {
         this.loadedItems++;

         // 当所有图片都加载完成后，重新布局
         if (this.loadedItems === this.productList.length) {
           this.$nextTick(() => {
             this.reflowWaterfall();
           });
         } else if (this.loadedItems >= this.columns) {
           // 当至少有一列的内容加载完成后，开始逐步重新布局
           this.$nextTick(() => {
             this.reflowWaterfall();
           });
         }
       },

       // 视频元数据加载完成后的回调
       onWaterfallVideoLoad(index) {
         this.loadedItems++;

         // 当所有视频都加载完成后，重新布局
         if (this.loadedItems === this.productList.length) {
           this.$nextTick(() => {
             this.reflowWaterfall();
           });
         } else if (this.loadedItems >= this.columns) {
           // 当至少有一列的内容加载完成后，开始逐步重新布局
           this.$nextTick(() => {
             this.reflowWaterfall();
           });
         }
       },

       // 监听窗口大小变化，调整瀑布流布局
       handleResize() {
         if (this.resizeTimer) {
           clearTimeout(this.resizeTimer);
         }

         this.resizeTimer = setTimeout(() => {
           this.initWaterfall();
           this.loadedItems = 0;

           // 重新触发图片加载事件
           const images = this.$refs.waterfallImages || [];
           images.forEach(img => {
             if (img.complete) {
               this.loadedItems++;
             }
           });

           // 重新触发视频加载事件
           const videos = this.$refs.waterfallVideos || [];
           videos.forEach(video => {
             if (video.readyState >= 1) {
               this.loadedItems++;
             }
           });

           if (this.loadedItems > 0) {
             this.$nextTick(() => {
               this.reflowWaterfall();
             });
           }
         }, 200);
       },
     },
  }
